import { Badge } from '@wartek-id/badge'

import { pelaksanaanStateLabel } from 'app/KinerjaKSPage/utils/states'

import type { PengawasSchool } from 'types/kinerja-ks-pelaksanaan'
import type { FC } from 'react'

interface BadgeObservationStatusProps {
  status: PengawasSchool['observationStatus']
}

const BadgeObservationStatus: FC<BadgeObservationStatusProps> = ({
  status = null,
}) => {
  const label = pelaksanaanStateLabel(status, '-')

  if (!status || label === '-') return <>-</>

  return (
    <Badge variant={status === 'COMPLETED' ? 'success' : 'neutral'}>
      {label}
    </Badge>
  )
}
export default BadgeObservationStatus
